// extracted by mini-css-extract-plugin
export default {"footer":"Q_k","row":"Q_dV","menu-column":"Q_dW"};